import React, { memo } from 'react';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

export const openMavenoidChat = (): void => {
  if (
    typeof document !== 'undefined' &&
    !document.querySelector('mavenoid-assistant')
  ) {
    globalThis?.mavenoidDeferredBoot?.();
  }
  globalThis?.mavenoid?.push({
    event: 'assistant-open',
  });
};

interface MavenoidChatButtonProps {
  buttonText?: string;
}

export const MavenoidChatButton = memo(
  ({ buttonText }: Readonly<MavenoidChatButtonProps>) => {
    const { tt } = useUiComponentsInternationalContext();
    return (
      <button
        type="button"
        onClick={openMavenoidChat}
        className="relative bg-transparent border-none cursor-pointer text-inherit leading-normal p-0 mr-2 hover:underline"
      >
        {buttonText ?? tt(s => s.openChatWidgetComponent.liveChatButton)}
      </button>
    );
  }
);

interface MavenoidChatFooterProps {
  footerText?: string;
}

export const MavenoidChatFooter = memo(
  ({ footerText }: Readonly<MavenoidChatFooterProps>) => {
    const { tt } = useUiComponentsInternationalContext();
    return (
      <button
        type="button"
        onClick={openMavenoidChat}
        className="relative bg-transparent border-none cursor-pointer text-inherit leading-normal mr-2 hover:underline p-0 m-0"
      >
        {footerText ??
          tt(s => s.openChatWidgetComponent.chatWithAgentNowButton)}
      </button>
    );
  }
);
